import template from './batch.edit.html';
import controller from './batch.edit.controller';
import './batch.edit.scss';

let batcheditComponent = {
  restrict: 'E',
  bindings: {
    hasACL:'='
  },
  template,
  controller
};

export default batcheditComponent;


// WEBPACK FOOTER //
// ./client/app/components/batch/edit/batch.edit.component.js